import React from 'react';
import AboutHeader from "./AboutHeader";
import Footer from './landing/Footer';
import Header from './landing/Header';

const TermsofService = () => {
   
    return (
        <div className="min-h-screen bg-white">
            <Header />
            {/* Solid Black Header */}
            <div className="bg-black py-16">
                <div className="container mx-auto px-4">
                    <h1 className="text-4xl md:text-5xl font-bold text-white text-center">
                        TERMS OF SERVICE
                    </h1>
                    <p className="text-sm text-white mt-8">
                        Effective Date: August 2025
                    </p>
                </div>
            </div>

            <div className="container mx-auto px-4 mb-8">
                {/* Content Section */}
                <div className="max-w-4xl mx-auto space-y-6">
                    <div className="max-w-4xl mx-auto px-4 py-12">
                        <div className="text-sm text-gray-700 leading-normal space-y-4">
                            <div>
                                <h2 className="font-semibold text-base mb-2">1. Agreement to Terms</h2>
                                <p className="mb-4">By accessing or using the services provided by ADHDRapidCare, you agree to be legally bound by these Terms of Service, our Privacy Policy, and all applicable laws and regulations. If you do not agree with any part of these terms, you must discontinue use immediately.</p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">2. Service Description</h2>
                                <p className="mb-2"><strong>Core Services Include:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>ADHD assessment and diagnosis via telehealth, enhanced by AI-supported analysis</li>
                                    <li>Qualified consultation and medication management</li>
                                    <li>Ongoing monitoring and reporting through nurse consultations supported by AI-tracked data</li>
                                    <li>Weekly AI-powered SMS check-ins and progress tracking</li>
                                    <li>Generation of AI-derived clinical insights reviewed by licensed professionals</li>
                                </ul>
                                
                                <p className="mb-2"><strong>Service Delivery Includes:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Secure video or telephone consultations with ADHD trained registered nurses</li>
                                    <li>Secure messaging portal and document access</li>
                                    <li>Automated SMS-based monitoring system</li>
                                    <li>Electronic prescription services (where applicable)</li>
                                    <li>Clinical reports and documentation via practitioner-reviewed AI systems</li>
                                </ul>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">3. Eligibility and Requirements</h2>
                                <p className="mb-2"><strong>Patient Eligibility:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Australian residents aged 18+ (minors require parental or guardian consent and support)</li>
                                    <li>Ability to meaningfully participate in telehealth sessions</li>
                                    <li>Proficiency in English for effective communication</li>
                                </ul>
                                
                                <p className="mb-2"><strong>Technical Requirements:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Internet-connected device (smartphone, tablet, or computer) with camera/microphone</li>
                                    <li>SMS capability for monitoring participation</li>
                                    <li>Stable internet connection and updated browser</li>
                                </ul>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">4. Account Registration and Security</h2>
                                <p className="mb-2">To use our services, you must:</p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Provide accurate and complete personal and medical information</li>
                                    <li>Maintain secure login credentials</li>
                                    <li>Keep your account information up to date</li>
                                    <li>Use your account only for your own care</li>
                                </ul>
                                <p className="mb-4">You are solely responsible for any activity under your account.</p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">5. Payments, Subscriptions, and Fees</h2>
                                <p className="mb-2"><strong>Assessment Services:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>One-time payment of the prescribed amount required prior to receiving service</li>
                                    <li>Includes comprehensive assessment, diagnosis, and treatment planning</li>
                                    <li>Additional fees may apply for extended sessions or complex cases</li>
                                </ul>
                                
                                <p className="mb-2"><strong>Care Plan Subscriptions:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>$79/month or $20/week subscription billed automatically</li>
                                    <li>Ongoing billing continues until cancelled</li>
                                    <li>30 days written notice required for cancellation</li>
                                    <li>No refunds for unused portions of subscription periods</li>
                                </ul>
                                
                                <p className="mb-2"><strong>Additional Fees:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Missed appointments without 24-hour notice: full session fee applies</li>
                                    <li>Rebooking missed appointments: $10 fee</li>
                                    <li>Additional consultations during billing period: charged separately</li>
                                    <li>Special documentation or administrative tasks: may incur additional fees</li>
                                </ul>
                                
                                <p className="mb-2"><strong>Payment Methods:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Credit/debit cards, bank transfers</li>
                                    <li>All fees are charged in Australian Dollars (AUD)</li>
                                </ul>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">6. Appropriate Use of Services</h2>
                                <p className="mb-2">You agree to:</p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Provide accurate information for both clinical and AI-assisted analysis</li>
                                    <li>Attend scheduled appointments and follow practitioner advice</li>
                                    <li>Respond to SMS check-ins for effective monitoring</li>
                                    <li>Use services for personal healthcare purposes only</li>
                                </ul>
                                
                                <p className="mb-2"><strong>Prohibited Activities Include:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Providing false or misleading information</li>
                                    <li>Attempting to obtain controlled substances fraudulently</li>
                                    <li>Abusing communication channels or violating practitioner boundaries</li>
                                    <li>Sharing your account or using services on behalf of others</li>
                                </ul>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">7. Clinical Care Standards</h2>
                                <p className="mb-2">All ADHDRapidCare practitioners:</p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Are registered with AHPRA</li>
                                    <li>Have specialized experience in ADHD assessment and care</li>
                                    <li>Carry appropriate insurance and engage in regular supervision</li>
                                </ul>
                                
                                <p className="mb-2">Care is delivered according to:</p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Best-practice clinical protocols</li>
                                    <li>Documentation and record-keeping standards</li>
                                    <li>Monitoring for safety and adverse effects</li>
                                </ul>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">8. Use of AI Technology</h2>
                                <p className="mb-4">Our services incorporate AI systems to enhance clinical support. These include:</p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Processing of assessment and monitoring data</li>
                                    <li>Generation of risk scores and clinical trend reports</li>
                                    <li>Predictive modeling and treatment optimization support</li>
                                    <li>SMS trend analysis for real-time care monitoring</li>
                                </ul>
                                
                                <p className="mb-4">All AI-generated content is reviewed by qualified clinicians before influencing care decisions.</p>
                                
                                <p className="mb-2"><strong>Limitations:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>AI outputs are not diagnoses</li>
                                    <li>AI systems may be affected by data quality, algorithmic bias, or system errors</li>
                                    <li>Patients have the right to request non-AI assessment upon written request</li>
                                </ul>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">9. Platform Use and System Limitations</h2>
                                <p className="mb-2"><strong>Platform Availability:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Services are offered on an "as-is, as-available" basis</li>
                                    <li>We do not guarantee uninterrupted access or uptime</li>
                                    <li>Scheduled maintenance and technical issues may cause temporary interruptions</li>
                                </ul>
                                
                                <p className="mb-2"><strong>Dependencies:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>SMS monitoring relies on third-party telecom carriers</li>
                                    <li>Electronic prescriptions depend on pharmacy/government systems</li>
                                    <li>Video consultations require adequate user-side internet and device compatibility</li>
                                </ul>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">10. Intellectual Property</h2>
                                <p className="mb-4">All content, materials, AI models, software, and branding on the ADHDRapidCare platform are the 
exclusive property of ADHDRapidCare Pty Ltd. You may not copy, distribute, or repurpose any part 
of the platform without express written permission. A limited license is granted for personal 
healthcare use only.</p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">11. Privacy and Data Use</h2>
                                <p className="mb-4">We collect, use, and protect your data in accordance with our Privacy Policy. Key highlights include:</p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Collection of clinical, personal, and technical data</li>
                                    <li>Use of AI to analyze de-identified data for commercial research purposes</li>
                                    <li>Commercial use rights for anonymised datasets</li>
                                    <li>Strict security protocols and storage policies</li>
                                </ul>
                                <p className="mb-4">For full details, see our full Privacy Policy document.</p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">12. Limitation of Liability</h2>
                                <p className="mb-4">To the fullest extent permitted by law, ADHDRapidCare is not liable for:</p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Diagnostic outcomes or medication effects</li>
                                    <li>Treatment results, delays, or unmet expectations</li>
                                    <li>Technical failures, third-party service outages, or data loss</li>
                                    <li>AI-generated misinterpretations or recommendations</li>
                                    <li>Missed SMS monitoring or patient-side technical issues</li>
                                    <li>Indirect, consequential, or special damages</li>
                                </ul>
                                <p className="mb-4">Maximum liability is capped at the amount paid for services in the 12 months preceding any claim.</p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">13. Termination</h2>
                                <p className="mb-2"><strong>By You:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Cancel subscription with 30 days written notice</li>
                                    <li>Data will be retained per our Privacy Policy</li>
                                </ul>
                                
                                <p className="mb-2"><strong>By Us:</strong></p>
                                <p className="mb-2">We may suspend or terminate access if:</p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Terms or policies are breached</li>
                                    <li>Fees are unpaid</li>
                                    <li>Clinical or safety concerns arise</li>
                                    <li>Required by law or regulation</li>
                                </ul>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">14. Dispute Resolution</h2>
                                <p className="mb-2">Disputes will be resolved through:</p>
                                <ol className="list-decimal pl-6 mb-4 space-y-1">
                                    <li>Direct communication with our support team</li>
                                    <li>Escalation to our Clinical Director if unresolved</li>
                                    <li>External mediation where appropriate</li>
                                    <li>Legal proceedings, if necessary, under Australian jurisdiction</li>
                                </ol>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">15. Governing Law</h2>
                                <p className="mb-4">These Terms are governed by the laws of New South Wales, Australia, and any applicable Commonwealth legislation. All legal proceedings will be handled within Australian courts.</p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">16. Modifications</h2>
                                <p className="mb-4">We may modify these Terms at any time. Continued use of our platform after changes indicates acceptance of the revised terms. The current version will always be available on our website.</p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">17. Assumption of Risk</h2>
                                <p className="mb-4">By using our services, you acknowledge and accept the inherent risks associated with telehealth, remote monitoring, and AI assisted care. These include potential limitations in diagnostic accuracy, data transmission, and system performance due to the nature of digital health technologies.</p>
                            </div>

                             <div>
                                <h2 className="font-semibold text-base mb-2">18. Notification of Policy Changes</h2>
                                <p className="mb-4">If we make material changes to our Terms of Service or Privacy Policy, we will notify users via email and/or an alert on our platform. Continued use of our services after such changes will constitute acceptance of the revised terms.</p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">19. Contact Information</h2>
                                <p className="mb-2"><strong>Customer Support:</strong> admin@adhdrapidcare.com.au</p>
                                <p className="mb-2"><strong>Legal Inquiries:</strong> admin@adhdrapidcare.com.au</p>
                                <p className="mb-4"><strong>Complaints:</strong> Clinical complaints may be escalated to the Health Care Complaints Commission or AHPRA if unresolved internally.</p>
                            </div>

                            <div className="mt-8 pt-4 border-t border-gray-300">
                                <p className="font-semibold mb-1">ADHDRapidCare Pty Ltd</p>
                                <p className="mb-1">ACN: 689674995</p>
                                {/* <p>Legal Contact: admin@adhdrapidcare.com.au</p> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default TermsofService;
